import React from 'react'
import './App.css'
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import {Bodyapplogin} from './components/bodyapplogin'
import {Bodyapploginsa} from './components/bodyapploginsa'
import {Bodyappsignup} from './components/bodyappsignup'
import {Bodyappactivate} from './components/bodyappactivate'
import {Bodyapparecopass} from './components/bodyapprecopass'
import {Bodyapparesetpass} from './components/bodyappresetpass'
import BodyTicketReport from "./components/reports/tickets/BodyTicketReport";
import Bodyapphome from './components/bodyapphome'
import Bodyappadmin from './components/bodyappadmin'
import Bodyappadmintickets from './components/bodyappadmintickets'
import BodyappadminUsers from './components/bodyappadminusers'
import BodyappadminRoles from './components/bodyappadminroles'
import BodyappadminSustituciones from './components/bodyappadminsustituciones'
import Bodyappadmincambios from './components/bodyappadmincambios'
import Bodyappadminwallet from './components/bodyappadminwallet'

import Bodyappminuta from './components/bodyappminuta'
import Bodyappticket from './components/bodyappticket'
import Bodyappwaitbuy from './components/bodyappwaitbuy'
import Bodyappcasinos from './components/bodyappcasinos'
import Bodyappempresas from './components/bodyappempresas'
import Bodyappgestiontickets from './components/bodyappgestiontickets'
import Bodyappgestionminutas from './components/bodyappgestionminutas'
import Bodyappticketreport from './components/bodyappticketreport'
import Bodyappusersreport from './components/bodyappusersreport'
import {toHaveStyle} from '@testing-library/jest-dom/dist/matchers'
import Bodyappconsolidtaedreport from "./components/bodyappconsolidatedreport";
import Bodyappnegativebalancereport from "./components/bodyappnegativebalancereport";
import Bodyappbilletera from "./components/bodyappbilletera"
import Bodyappmovwalletreport from "./components/bodyappmovwalletreport"
import Bodyappcompracafeteria from "./components/bodyappcompracafeteria"
import Bodyappgestioncomandas from "./components/bodyappgestioncomandas"
import Bodyappgestionproductos from "./components/bodyappgestionproductos"
import Bodyappordenesreport from "./components/bodyappordenesreport"
class App extends React.Component {
    constructor(props) {
        super(props);
        this.setStateMail = this.setStateMail.bind(this);
        this.setStateApiKey = this.setStateApiKey.bind(this);
        this.setStateAuthCode = this.setStateAuthCode.bind(this)
        this.setStateValorTicket = this.setStateValorTicket.bind(this);
    }

    state = {
        mail: '',
        apikey: '',
        authCode: '',
        valorticket: 0
    }

    render() {
        return (
            <Router>
                <Routes>
                    <Route path='/' 
                        element={<Bodyapplogin/>} exact/>
                                        
                    <Route
                        path='/LoginSA'
                        element={<Bodyapploginsa/>} exact/>

                    <Route
                        path='/Admin/:loginToken'
                        element={<Bodyappadmin/>} exact/>

                    <Route
                        path='/AdminTickets/:loginToken'
                        element={<Bodyappadmintickets/>} exact/>

                    <Route
                        path='/AdminUsers/:loginToken'
                        element={<BodyappadminUsers/>} exact/>

                    <Route
                        path='/AdminRoles/:loginToken'
                        element={<BodyappadminRoles/>} exact/>

                    <Route
                        path='/AdminWallet/:loginToken'
                        element={<Bodyappadminwallet/>} exact/>

                    <Route
                        path='/AdminCambios/:loginToken'
                        element={<Bodyappadmincambios/>} exact/>

                    <Route
                        path='/Register'
                        element={<Bodyappsignup setStateMailP={this.setStateMail}/>} exact/>

                    <Route
                        path='/Activate'
                        element={<Bodyappactivate mailRegister={this.state.mail}/>} exact/>

                    <Route
                        path='/RecoverPassword'
                        element={<Bodyapparecopass/>} exact/>

                    <Route
                        path='/ResetPassword'
                        element={<Bodyapparesetpass/>} exact/>

                    <Route
                        path='/Home/:loginToken'
                        element={<Bodyapphome/>} exact/>

                    <Route
                        path='/Ticket/:loginToken'
                        element={<Bodyappticket/>} exact/>

                    <Route
                        path='/WaitBuy/:loginToken'
                        element={<Bodyappwaitbuy/>} exact/>

                    <Route
                        path='/Casinos/:loginToken'
                        element={<Bodyappcasinos/>} exact/>

                    <Route
                        path='/Empresas/:loginToken'
                        element={<Bodyappempresas/>} exact/>

                    <Route
                        path='/GestionTickets/:loginToken'
                        element={<Bodyappgestiontickets/>} exact/>

                    <Route
                        path='/GestionMinutas/:loginToken'
                        element={<Bodyappgestionminutas/>} exact/>

                    <Route
                        path='/GestionComandas/:loginToken'
                        element={<Bodyappgestioncomandas/>} exact/>

                    <Route
                        path='/GestionProductos/:loginToken'
                        element={<Bodyappgestionproductos/>} exact/>
                                        
                    <Route
                        path='/Minuta/:loginToken'
                        element={<Bodyappminuta/>} exact/>

                    <Route 
                        path='/ReporteCompraTickets/:loginToken' 
                        element={<Bodyappticketreport/>} exact/>

                    <Route 
                        path='/ReporteConsolidados/:loginToken' 
                        element={<Bodyappconsolidtaedreport/>} exact/>

                   <Route 
                        path='/ReporteSaldosNegativos/:loginToken' 
                        element={<Bodyappnegativebalancereport/>} exact/>

                    <Route 
                        path='/ReporteUsuarios/:loginToken' 
                        element={<Bodyappusersreport/>} exact/>

                    <Route 
                        path='/Billetera/:loginToken' 
                        element={<Bodyappbilletera/>} exact/>

                    <Route 
                        path='/BilleteraMov/:loginToken' 
                        element={<Bodyappmovwalletreport/>} exact/>

                    <Route 
                        path='/CompraCafeteria/:loginToken' 
                        element={<Bodyappcompracafeteria/>} exact/>

                    <Route 
                        path='/OrdenesCafeteria/:loginToken' 
                        element={<Bodyappordenesreport/>} exact/>
                </Routes>
            </Router>

        );
    }

    setStateMail(value) {
        this.setState({mail: value});
    }

    setStateApiKey(value) {
        this.setState({apikey: value});
    }

    setStateValorTicket(value) {
        this.setState({valorticket: value});
    }

    setStateAuthCode(value) {
        this.setState({authCode: value})
    }


}

export default App;
